import { useTextCardForm } from "@/components/shared/forms/text-card-form";
import type { TextCard } from "@stackje/common/config";

interface EditTextCardProps {
  card: TextCard;
  cardIndex: number;
}

export function EditTextCard({ card }: EditTextCardProps) {
  const { formContent, previewContent, shuffleColors, handleSubmit } = useTextCardForm({
    initialData: {
      title: card.title || "",
      subtitle: card.subtitle || "",
      type: "text1",
      colors: card.colors,
    },
    mode: "edit",
  });

  return {
    formContent,
    previewContent,
    shuffleColors,
    handleSubmit,
  };
}
